import AppointmentButton from '../../../component/appointments/AppointmentButton';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import styles from './TentProviderCard.module.css';
import Tentimgcard from '../../../assets/images/icon 9/300x300 tenthouse equipment (1) 1.png';
import { useSelector } from 'react-redux';

const TentProviderCard = ({ 
  provider, 
  isInCart, 
  onAddToCart, 
  onRemoveFromCart,
  quantity,
  onQuantityChange 
}) => {
  const { commonData } = useSelector(state => state.serviceBooking);
  const [showItems, setShowItems] = useState(false);
  
  console.log("data for _tent", quantity, provider);
  
  const selectedItemsMap = commonData.selectedTentItems?.reduce((map, item) => {
    map[item.id] = item.count || 1;
    return map;
  }, {}) || {};
  
  // Calculate total prices from ALL services
  const totalOriginalPrice = provider.services?.reduce((sum, service) => {
    const quantity = selectedItemsMap[service.id] || 1;
    return sum + ((service.price || 0) * quantity);
  }, 0) || 0;

  const totalDiscountPrice = provider.services?.reduce((sum, service) => {
    const quantity = selectedItemsMap[service.id] || 1;
    const price = service.discountPrice || service.price || 0;
    return sum + (price * quantity);
  }, 0) || 0;
  
  // Check if there's any discount across all services
  const hasDiscount = totalDiscountPrice < totalOriginalPrice;
  const totalSavings = totalOriginalPrice - totalDiscountPrice;

  // Calculate total prices based on quantity
  const totalQuantityOriginalPrice = totalOriginalPrice * quantity;
  const totalQuantityDiscountPrice = totalDiscountPrice * quantity;
  const totalQuantitySavings = totalSavings * quantity;

  // Get individual service prices with quantities
  const getServiceItemsWithPrices = () => {
    return provider.services?.map(service => {
      const selectedItem = commonData.selectedTentItems?.find(item => item.id === service.serviceId);
      const itemQuantity = selectedItem?.count || 1;
      const originalPrice = (service.price || 0) * itemQuantity;
      const discountPrice = (service.discountPrice || service.price || 0) * itemQuantity;
      
      return {
        ...service,
        itemQuantity,
        originalPrice,
        discountPrice,
        hasDiscount: service.discountPrice && service.discountPrice < service.price
      };
    }) || [];
  };

  const serviceItems = getServiceItemsWithPrices();

  return (
    <div className={styles.quicklinktentCard}>
      <AppointmentButton providerId={provider.providerId || provider.id} providerName={provider.businessName || provider.name} source="quick-service" />
      <div className={styles.quicklinktentheadder}>
        <div className={styles.yearsofexp}>
          <span className={styles.expcount}>10+ Years Of Experience</span>
          <span className={styles.rating}>4.5</span>
        </div>
        <div className={styles.distanceInMeter}>
          <span>{Number(provider.originalData.distanceInMeter).toFixed(2)} km</span>
        </div>
      </div>
      <div className={styles.quicklinktentContent}>
        {/* Left side - Provider details */}
        <div className={styles.quicklinktentDetails}>
          <h3 className={styles.quicklinktentName}>{provider.name}</h3>
          
          {/* Price Display */}
          <div className={styles.quicklinktentPriceContainer}>
            {hasDiscount ? (
              <div className={styles.quicklinktentDiscountPriceSection}>
                <div className={styles.quicklinktentPriceRow}>
                  <span className={styles.quicklinktentOriginalPrice}>₹{totalQuantityOriginalPrice}</span>
                  <span className={styles.quicklinktentDiscountPrice}>₹{totalQuantityDiscountPrice}</span>
                </div>
                <div className={styles.quicklinktentSavings}>
                  Save ₹{totalQuantitySavings}
                </div>
                <div className={styles.quicklinktentPerUnit}>
                  (₹{totalDiscountPrice} per set)
                </div>
              </div>
            ) : (
              <div className={styles.quicklinktentPriceSection}>
                <span className={styles.quicklinktentPrice}>₹{totalQuantityOriginalPrice}</span>
              </div>
            )}
          </div>

     
        </div>

        {/* Right side - Image with overlapping button */}
        <div className={styles.quicklinktentImageContainer}>
          <div className={styles.quicklinktentImage}>
            <img 
              src={Tentimgcard} 
              alt={provider.name}
              onError={(e) => {
                e.target.src = Tentimgcard;
              }}
            />
            <div className={styles.quicklinktentOverlayButton}>
              {isInCart ? (
                <Button
                  label="Remove"
                  icon="pi pi-times"
                  className={styles.quicklinktentRemoveButton}
                  onClick={() => onRemoveFromCart(provider.id)}
                />
              ) : (
                <Button
                  label="Add"
                  icon="pi pi-plus"
                  className={styles.quicklinktentAddButton}
                  onClick={() => onAddToCart(provider)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
           {/* Show Items Button */}
          <div className={styles.showItemsContainer}>
            <Button
              label={showItems ? "Hide Items" : "Show Items"}
              icon={showItems ? "pi pi-chevron-up" : "pi pi-chevron-down"}
              className={styles.showItemsButton}
              onClick={() => setShowItems(!showItems)}
            />
          </div>

          {/* Items List */}
          {showItems && (
            <div className={styles.itemsList}>
              {serviceItems.map((service) => (
                <div key={service.serviceId} className={styles.serviceItem}>
                  <div className={styles.serviceInfo}>
                    <span className={styles.serviceName}>{service.serviceName}</span>
                    <span className={styles.serviceQuantity}>×{service.itemQuantity}</span>
                  </div>
                  <div className={styles.servicePrice}>
                    {service.hasDiscount ? (
                      <div className={styles.serviceDiscountPrice}>
                        <span className={styles.serviceOriginalPrice}>₹{service.originalPrice}</span>
                        <span className={styles.serviceFinalPrice}>₹{service.discountPrice}</span>
                      </div>
                    ) : (
                      <span className={styles.serviceFinalPrice}>₹{service.originalPrice}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
    </div>
  );
};

export default TentProviderCard;